import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { UpdateChatStatus } from '../../features/chat.actions';
import { selectChatStatus } from '../../features/chat.selectors';

@Component({
  selector: 'app-chat-button',
  templateUrl: './chat-button.component.html',
  styleUrls: ['./chat-button.component.scss']
})
export class ChatButtonComponent implements OnDestroy {

  public status$ = this.store.pipe(
    select(selectChatStatus)
  );

  constructor(
    public store: Store
  ) { }

  ngOnDestroy(): void {
    this.store.dispatch({
      type: UpdateChatStatus.type,
      status: 'closed'
    });
  }

  onToggle(status) {
    switch(status) {
      case 'closed':
        this.store.dispatch({
          type: UpdateChatStatus.type,
          status: 'opened'
        });
        break;
      case 'opened':
        this.store.dispatch({
          type: UpdateChatStatus.type,
          status: 'closed'
        });
        break;
      default:
        this.store.dispatch({
          type: UpdateChatStatus.type,
          status: 'closed'
        });
    }
  }

}
